import { ref, watch, unref } from '@vue/composition-api';
import { useMutation } from 'vue-query';
import { useContext } from '@berlin-front/common/composables/context';
import useOrAll from '@berlin-front/common/composables/useOrAll';
import { noOperation, notNil } from '@berlin-front/common/utils';
import { ApiCacheContext } from './ApiCacheContext';
import { BerlinBffContext } from './BerlinBff';

type LogoutOptions = {
  deleteToken?: boolean;
  onLogout?: () => void;
};

export default () => {
  const { authenticate } = useContext(BerlinBffContext);
  const { tokens, logout, atoneModalParameter } = useContext(ApiCacheContext);
  const isLogouting = ref(false);
  const isLogouted = ref(false);

  const onLogoutRef = ref(noOperation);

  // ログアウトの実行。
  const {
    mutate,
    isSuccess: isLogoutError,
    isError: isLogoutSuccess,
  } = useMutation('atone.AuthenticateDelete', () =>
    authenticate.atoneAuthenticateControllerAuthenticateDelete(
      notNil(tokens.value.npToken),
      atoneModalParameter.value.pubKey,
    ),
  );

  watch(useOrAll(isLogoutError, isLogoutSuccess), (value) => {
    // エラーか成功したらAPIキャッシュをクリアして、ログアウト終了フラグをたて、後処理を実行する。
    if (value) {
      logout();
      isLogouted.value = true;
      onLogoutRef.value();
    }
  });

  return {
    /**
     * @param deleteToken 決済認証トークンを無効化するかどうか。
     */
    logout: (logoutOptions?: LogoutOptions) => {
      const { onLogout, deleteToken } = { onLogout: noOperation, deleteToken: false, ...logoutOptions };
      onLogoutRef.value = onLogout;
      if (!unref(isLogouting)) {
        isLogouting.value = true;
        if (deleteToken) {
          mutate();
        } else {
          logout();
          isLogouted.value = true;
          onLogoutRef.value();
        }
      }
    },
    isLogouting,
  };
};
